import styled from 'styled-components'

export const FullScreenOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

export const FullScreenContainer = styled.div<{ accentColor: string }>`
  max-width: 700px;
  width: 100%;
  min-height: 500px;
  display: grid;
  place-items: center;
  text-align: center;
  position: relative;

  box-shadow: 1px 12px 25px rgba(0, 0, 0, 0.78);
  border-radius: 2em;
  border: none;
  padding: 5rem 2rem 3rem 2rem;

  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.modal || '34, 34, 34'})` : '#ffffff'};

  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};

  @media (max-width: 768px) {
    min-height: 400px;
    padding: 2em 1.5em;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.high || '13, 13, 13'})` : '#e0e0e0'};
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: #c53030;
    color: #ffffff;
    transform: scale(1.1);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`

export const MinimizeButton = styled.button`
  position: absolute;
  top: 20px;
  right: 70px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.high || '13, 13, 13'})` : '#e0e0e0'};
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) =>
      theme.isDark ? `rgb(${theme.grayscale?.['400'] || '74, 74, 74'})` : '#ccc'};
    transform: scale(1.1);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`

export const HelpButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.high || '13, 13, 13'})` : '#e0e0e0'};
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) =>
      theme.isDark ? `rgb(${theme.grayscale?.['400'] || '74, 74, 74'})` : '#ccc'};
    transform: scale(1.1);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`

export const DisciplineTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 600;
  margin: 0;
  margin-bottom: 0.5em;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-top: 2rem;
  }
`

export const TimeDisplayLarge = styled.h1`
  font-size: 5rem;
  margin: 0;
  margin-bottom: 0.1em;
  font-weight: 700;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};
  font-variant-numeric: tabular-nums;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 3.5rem;
  }
`

export const StatusText = styled.p`
  font-size: 0.95rem;
  font-weight: 600;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['200'] || '74, 74, 74'})` : '#999'};
  margin: 0;
  margin-bottom: 1em;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`

export const ProgressSectionLarge = styled.div`
  width: 100%;
  margin: 2em auto;
`

export const ProgressLabelLarge = styled.span`
  text-align: left;
  font-weight: 600;
  font-size: 1rem;
  width: 100%;
  display: block;
  margin-bottom: 0.8rem;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['200'] || '207, 207, 207'})` : '#666'};
`

export const ProgressBarLarge = styled.div`
  position: relative;
  width: 100%;
  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.high || '13, 13, 13'})` : '#e0e0e0'};
  height: 8px;
  display: block;
  border-radius: 50px;
  overflow: hidden;
`

export const ProgressFillLarge = styled.div<{ progress: number; color: string }>`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background: #1edd0e;
  border-radius: 50px;
  transition: width 0.3s ease;
`

export const ProgressValueLarge = styled.span`
  margin-top: 0.8rem;
  text-align: right;
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};
`

export const AddedTimeBadgeLarge = styled.span`
  display: block;
  width: fit-content;
  margin: 0.5rem 0 0 auto;
  padding: 0.25rem 0.75rem;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  background: ${({ theme }) =>
    theme.isDark ? 'rgba(30, 221, 14, 0.2)' : 'rgba(30, 221, 14, 0.15)'};
  color: #1edd0e;
  border: 1px solid rgba(30, 221, 14, 0.3);

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.2rem 0.6rem;
  }
`

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 12px;
  }
`

export const IconButton = styled.button<{ active?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  min-width: 56px;
  height: 48px;
  padding: 0 16px;
  border-radius: 12px;
  border: none;
  background: #3366cc;
  color: #ffffff;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) {
    color: #ffffff;
    background: #3366cc88;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    min-width: 48px;
    height: 48px;
    padding: 0 12px;

    svg {
      width: 20px;
      height: 20px;
    }

    span {
      font-size: 0.85rem !important;
    }
  }
`

export const LargeIconButton = styled.button<{ active?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 0 24px;
  border-radius: 24px;
  border: 2px solid #3366cc;
  background: ${({ active, theme }) => (active ? '#3366cc' : 'transparent')};
  color: ${({ active, theme }) =>
    active
      ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})`
      : `rgb(${theme.grayscale?.['200'] || '207, 207, 207'})`};
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) {
    color: ${({ theme }) => `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})`};
    background: #3366cc88;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    min-width: 48px;
    height: 48px;
    padding: 0 12px;

    svg {
      width: 20px;
      height: 20px;
    }

    span {
      font-size: 0.85rem !important;
    }
  }
`

export const SeparatorLarge = styled.div`
  width: 2px;
  height: 40px;
  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.high || '13, 13, 13'})` : '#e0e0e0'};
  margin: 0 8px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const AddTimeSection = styled.div`
  margin-top: 2.5em;
  text-align: center;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`

export const AddTimeLabel = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['200'] || '74, 74, 74'})` : '#666'};
  margin: 0 0 1em 0;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`

export const AddTimeButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`
